import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as n } from "../../../../IconBase-CxZyIWw2.js";
const t = r((e, i) => /* @__PURE__ */ o.jsx(
  n,
  {
    ref: i,
    ...e,
    image: (l) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM16.914 20H15.08v-6.855h-2.596v-1.547h7.026v1.547h-2.596z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "TretinoinIcon";
export {
  t as TretinoinIcon,
  t as default
};
//# sourceMappingURL=index.js.map
